import { create as e } from "zustand";
import { persist as a, createJSONStorage as t } from "zustand/middleware";
const n = e()(
  a(
    (i) => ({
      previousPath: null,
      previousLocation: null,
      isSideNavigationOpen: !0,
      isSportsPage: !1,
      toggleSideNavigation: () => i((o) => ({ isSideNavigationOpen: !o.isSideNavigationOpen })),
      setPreviousPath: (o) => i({ previousPath: o }),
      setPreviousLocation: (o) => i({ previousLocation: o }),
      setIsSportsPage: (o) => i({ isSportsPage: o })
    }),
    {
      name: "navigation-storage",
      storage: t(() => localStorage),
      partialize: (i) => ({
        previousPath: i.previousPath,
        previousLocation: i.previousLocation,
        isSideNavigationOpen: i.isSideNavigationOpen
      })
    }
  )
);
export {
  n as useNavigationStore
};
